import { s } from '@/theme/tokens';
import { Panel } from '@/ui/composites/Panel';
import { Box } from '@/ui/primitives';
import { TABLE_PANEL_HEADER_HEIGHT } from '../tableSystem/tableConstants';
import type { ReactElement, ReactNode } from 'react';

type MetricChartPanelProps = {
  header: ReactNode;
  children: ReactNode;
  width?: number;
  height?: number;
  headerHeight?: number;
  panelPaddingTop?: string | number;
  panelPaddingBottom?: string | number;
  headerPaddingX?: string | number;
  headerPaddingTop?: string | number;
  headerPaddingBottom?: string | number;
  contentPaddingX?: string | number;
  contentPaddingTop?: string | number;
  contentPaddingBottom?: string | number;
};

export const MetricChartPanel = ({
  header,
  children,
  width,
  height,
  headerHeight = TABLE_PANEL_HEADER_HEIGHT,
  panelPaddingTop = s('none'),
  panelPaddingBottom = s('xxs'),
  headerPaddingX = s('xl'),
  headerPaddingTop = s('xxs'),
  headerPaddingBottom = s('xxs'),
  contentPaddingX = s('xl'),
  contentPaddingTop = s('none'),
  contentPaddingBottom = s('xxs'),
}: MetricChartPanelProps): ReactElement => (
  <Panel
    padding={null}
    gap="none"
    contentGap="none"
    headerGap="none"
    headerSlot={
      <Box
        sx={{
          minHeight: `${headerHeight}px`,
          height: `${headerHeight}px`,
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          px: headerPaddingX,
          pt: headerPaddingTop,
          pb: headerPaddingBottom,
        }}
      >
        {header}
      </Box>
    }
    sx={[
      {
        backgroundColor: 'background.paper',
        pt: panelPaddingTop,
        pb: panelPaddingBottom,
      },
      width
        ? {
            width: `${width}px`,
            minWidth: `${width}px`,
            maxWidth: `${width}px`,
          }
        : null,
      height ? { minHeight: `${height}px` } : null,
    ]}
  >
    <Box
      sx={{
        px: contentPaddingX,
        pt: contentPaddingTop,
        pb: contentPaddingBottom,
      }}
    >
      {children}
    </Box>
  </Panel>
);
